<template>

  <v-menu
  v-if="user"
  bottom
  left>

    <v-avatar
    slot="activator"
    :color="photoURL ? 'white' : 'primary'">
      <img
      v-if="photoURL"
      :src="photoURL"
      :alt="displayName"
      />
      <!-- <span
      v-if="!photoURL"
      class="white--text headline"
      >{{ placeholder }}</span> -->
      <v-icon
      v-if="!photoURL"
      dark>account_circle</v-icon>
    </v-avatar>

    <v-list>

      <v-list-tile avatar @click="$router.push('/user')">
        <v-list-tile-avatar :color="photoURL ? 'white' : 'primary'">
          <img
          v-if="photoURL"
          :src="photoURL"
          :alt="displayName"
          />
          <!-- <span
          v-if="!photoURL"
          class="white--text headline"
          >{{ placeholder }}</span> -->
          <v-icon
          v-if="!photoURL"
          dark>account_circle</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ displayName }}</v-list-tile-title>
          <!-- <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title> -->
        </v-list-tile-content>

        <!-- <v-list-tile-action>
          <v-btn icon ripple>
            <v-icon color="grey lighten-1">info</v-icon>
          </v-btn>
        </v-list-tile-action> -->
      </v-list-tile>

      <v-divider ></v-divider>

      <v-list-tile @click="signOut">
        <v-list-tile-avatar>
          <v-icon left>exit_to_app</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile-content>

        <!-- <v-list-tile-action>
          <v-switch v-model="message" color="purple"></v-switch>
        </v-list-tile-action>
        <v-list-tile-title>Enable messages</v-list-tile-title> -->
      </v-list-tile>

      <!-- <v-list-tile>
        <v-list-tile-action>
          <v-switch v-model="hints" color="purple"></v-switch>
        </v-list-tile-action>
        <v-list-tile-title>Enable hints</v-list-tile-title>
      </v-list-tile> -->

    </v-list>
  </v-menu>
</template>

<script>
// import { auth } from '@/firebase.js';
// import { /*mapGetters,*/ mapState } from 'vuex';
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')

export default {
  name: 'UserIcon',
  data() {
    return {
      debug: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),

    displayName() {
      if (this.debug) console.log(this.$options.name+'.displayName() user:',this.user);
      if (!this.user || !this.user.displayName) return '';
      else return this.user.displayName;
    },
    photoURL() {
      if (this.debug) console.log(this.$options.name+'.photoURL() user:',this.user);
      if (!this.user || !this.user.photoURL) return null;
      else return this.user.photoURL;
    }
  },

  props: {},

  watch: {
    user: function(val) {
      if (this.debug) console.log(this.$options.name+'.user() user:',this.user,'val:',val);
    }
  },

  methods: {
    ...mapActions([
      'signOutUser' // map `this.signOutUser()` to `this.$store.dispatch('projects/signOutUser')`
    ]),

    signOut: function(user) {
      if (this.debug) console.log(this.$options.name+'signOut() user:',user)
      this.signOutUser()
      .then(() => {
        // Sign-out successful.
        if (this.debug) console.log(this.$options.name+'signOut() OK')
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'signOut() error:',error)
        // An error happened.
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
